import React, {useState} from "react";
import * as palette from "../Variables";
import styled from "styled-components";

const StyledPainPoint = styled.div`
display: flex;
align-items: center;
column-gap: 12px;

@media (min-width: 768px) {
    column-gap: 24px;
}

div.img-container {
    width: 48px;
    height: 48px;
    min-width: 48px;
    min-height: 48px;
    border-radius: 100px;
    overflow: hidden;

    @media (min-width: 768px) {
        min-width: 64px;
        min-height: 64px;
        width: 64px;
        height: 64px;
    }

    img {
        width: 100%;
        object-fit: cover;
    }
}

p {
    margin: 0;
}
`;

const PainPoint = ({src, alt, quote1, semibold, quote2}) => {
    return (
        <StyledPainPoint>
            <div className={"img-container"}>
                <img src={src} alt={alt}/>
            </div>
            <p>{quote1}<span className="semibold">{semibold}</span>{quote2}</p>
        </StyledPainPoint>
    )
}

export default PainPoint;